var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPrioritysignRoundabout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "prioritysign_x5F_roundabout_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "96px",
    viewBox: "0 0 48 96",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "priority_x5F_sign"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#154989",
    cx: 24,
    cy: 72,
    r: 22
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M24,50c12.1,0,22,9.9,22,22s-9.9,22-22,22S2,84.1,2,72S11.9,50,24,50 M24,49C11.3,49,1,59.3,1,72 s10.3,23,23,23s23-10.3,23-23S36.7,49,24,49L24,49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M26.8,57.7l7.3-2l2.9,1.7l-5.5,1.5c4.7,2.7,7.6,7.7,7.6,13.1c0,1.8-0.3,3.5-0.9,5.2l-2.5-0.9 c0.5-1.4,0.8-2.8,0.8-4.3c0-4.5-2.4-8.6-6.2-10.8l1.5,5.5L29,65.1L26.8,57.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M10.2,76.7l-5.4-5.4V68l4,4c0-7.3,5.3-13.6,12.5-14.9l0.5,2.6c-6,1-10.3,6.2-10.3,12.3l4-4v3.2L10.2,76.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M35,81.6l-2,7.3l-2.9,1.7l1.5-5.5c-2.3,1.3-4.9,2-7.6,2c-4.5,0-8.7-2-11.6-5.4l2.1-1.7 c2.4,2.8,5.9,4.4,9.5,4.4c2.2,0,4.3-0.6,6.2-1.7l-5.5-1.5l2.7-1.6L35,81.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M42.6,5H5.4C4.4,5,3.4,5.6,2.9,6.5c-0.5,0.9-0.5,2.1,0,3L21.4,42c0.5,0.9,1.5,1.5,2.6,1.5s2.1-0.6,2.6-1.5 L45.2,9.5c0.5-0.9,0.5-2.1,0-3C44.6,5.6,43.6,5,42.6,5L42.6,5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B33229",
    d: "M40.8,9L24,38.5L8,9H40.8 M42.6,6H5.4C3.9,6,2.9,7.7,3.7,9l18.6,32.5c0.4,0.7,1.1,1,1.7,1s1.4-0.3,1.7-1 L44.3,9C45.1,7.7,44.1,6,42.6,6L42.6,6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrioritysignRoundabout);
export default __webpack_public_path__ + "static/media/icon-prioritysign_roundabout.4d42199b6d937d2f45186faa34b9b81d.svg";
export { ForwardRef as ReactComponent };